import { render } from "./CardContainer.vue?vue&type=template&id=20f3c998"
import script from "./CardContainer.vue?vue&type=script&lang=js"
export * from "./CardContainer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__